import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGroups, hasAccess } from '../utils/useGroups';

/**
 * ProtectedRoute
 * Wraps a route and redirects to /access-denied if the user
 * doesn't belong to at least one of the allowed groups.
 *
 * Usage in App.js:
 *   <Route path="/fulfillment" element={
 *     <ProtectedRoute groups={['membership', 'superadmin']}>
 *       <FulfillmentTracker />
 *     </ProtectedRoute>
 *   } />
 *
 * While groups are loading, renders nothing to avoid a flash
 * of the protected content before the check completes.
 */
export default function ProtectedRoute({ groups: allowedGroups, children }) {
  const { groups, loading } = useGroups();

  // Still fetching session — render nothing to avoid flicker
  if (loading) return null;

  // Not in any allowed group — redirect
  if (!hasAccess(groups, allowedGroups)) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
}